<template>
  <div class="pageContent">
    <searchHospital :LocationFail="LocationFail" />
  </div>
</template>
<script>
import searchHospital from '@/components/findHospital/index.vue'
// import { institutionNameSearch } from '@/api/check'
export default {
  name: 'findHospital',
  components: { searchHospital },
  data() {
    return {
      // hospitalList: []
      LocationFail: ''
    }
  },
  methods: {
    // async getInstitutionNameSearch(params) {
    //   let res = await institutionNameSearch(params)
    //   if (res) {
    //     this.hospitalList = res
    //   }
    // }
  },
  created() {
    if (this.$route.query.LocationFail) {
      this.LocationFail = this.$route.query.LocationFail
    } else {
      this.LocationFail = false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>


